/*
 * Built with Common Launchpad 2.0.3
 */

import FormTools from '../utils/formTools';
import FormHelper from '~/src/custom/js/utils/formhelper';

window.FormTools = new FormTools();
window.FormHelper = new FormHelper();

$(() => {
	window.FormTools.init();
	window.kentico.originalUpdatableFormHelper = window.kentico.updatableFormHelper;
	window.kentico.updatableFormHelper = new FormHelper();
});